module.exports = __webpack_public_path__ + "2e77fe746409670a8f31a9d55b944e86.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/avatars/AvatarArabella4.png
// module id = 24
// module chunks = 0